module.exports = __webpack_public_path__ + "img/Group 2419.780d5477.svg";